import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { EditTransportComponent } from './component/edit-transport.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from '../transport-options-panel/transport-options-panel.module';
import { TransportDetailsModule } from 'src/tmc-yard/common/components/transport-details/transport-details.module';


@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportDetailsModule,
    TransportOptionsPanelModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule
  ],
  declarations: [
    EditTransportComponent],
  exports: []
})
export class EditTransportModule { }
